module.exports = __webpack_public_path__ + "static/media/7.42217f70.webp";